import { Injectable } from '@angular/core';
import { AddressFormValue } from 'src/app/cws2.0/shared/address/models/address.model';
import { PhoneFormValue } from 'src/app/cws2.0/shared/phone/models/phone.model';
import { AddressTelephoneContract } from './address-telephone-change.interfaces';

export interface AddressTelephoneChangeState {
  isAddressChangeSelected: boolean;
  isPhoneChangeSelected: boolean;
  address?: AddressFormValue;
  phone?: PhoneFormValue;
  companyReceivedDateFormatted: string;
}

const DEFAULT_STATE: AddressTelephoneChangeState = {
  isAddressChangeSelected: false,
  isPhoneChangeSelected: false,
  address: undefined,
  phone: undefined,
  companyReceivedDateFormatted: '',
};

@Injectable({
  providedIn: 'root',
})
export class AddressTelephoneChangeService {
  private static readonly STORAGE_KEY = 'address-telephone-change:state';

  private state: AddressTelephoneChangeState = { ...DEFAULT_STATE };
  private contracts?: AddressTelephoneContract[];

  getState(): AddressTelephoneChangeState {
    this.syncStateFromStorage();
    return { ...this.state };
  }

  setState(nextState: Partial<AddressTelephoneChangeState>): void {
    this.syncStateFromStorage();
    this.state = { ...this.state, ...nextState };
    this.persistState();
  }

  setChangeSelection(isAddressChangeSelected: boolean, isPhoneChangeSelected: boolean): void {
    this.setState({ isAddressChangeSelected, isPhoneChangeSelected });
  }

  setAddress(address: AddressFormValue | undefined): void {
    this.setState({ address });
  }

  setPhone(phone: PhoneFormValue | undefined): void {
    this.setState({ phone });
  }

  getContracts(): AddressTelephoneContract[] | undefined {
    return this.contracts ? [...this.contracts] : undefined;
  }

  setContracts(contracts: AddressTelephoneContract[]): void {
    this.contracts = [...contracts];
  }

  resetState(): void {
    this.state = { ...DEFAULT_STATE };
    this.contracts = undefined;
    sessionStorage.removeItem(AddressTelephoneChangeService.STORAGE_KEY);
  }

  clear(): void {
    this.resetState();
  }

  private persistState(): void {
    sessionStorage.setItem(AddressTelephoneChangeService.STORAGE_KEY, JSON.stringify(this.state));
  }

  private syncStateFromStorage(): void {
    const stored = sessionStorage.getItem(AddressTelephoneChangeService.STORAGE_KEY);
    if (!stored) {
      return;
    }

    try {
      this.state = { ...DEFAULT_STATE, ...(JSON.parse(stored) as AddressTelephoneChangeState) };
    } catch {
      this.state = { ...DEFAULT_STATE };
    }
  }
}
